import { render, staticRenderFns } from "./ClaimStageField.vue?vue&type=template&id=46cc4d2a"
import script from "./ClaimStageField.vue?vue&type=script&lang=js"
export * from "./ClaimStageField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports